import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { RolDto } from "../../../types/ajustes";
import SectionState from "./SectionState";

interface RolesTabProps {
  roles: RolDto[];
  loading: boolean;
  error: string | null;
  onReload: () => void;
  onCreate: () => void;
  onEdit: (rol: RolDto) => void;
  canCreate: boolean;
  canEdit: boolean;
}

const RolesTab = ({ roles, loading, error, onReload, onCreate, onEdit, canCreate, canEdit }: RolesTabProps) => {
  return (
    <Card>
      <CardBody>
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <CardTitle tag="h5" className="mb-1">
              Roles disponibles
            </CardTitle>
            <p className="text-muted mb-0">Define permisos y políticas de acceso.</p>
          </div>
          <div className="d-flex gap-2">
            <Button color="light" onClick={onReload}>
              Actualizar
            </Button>
            <Button color="primary" onClick={onCreate} disabled={!canCreate}>
              Nuevo rol
            </Button>
          </div>
        </div>

        <SectionState
          loading={loading}
          error={error}
          description="Cargando roles..."
          onRetry={onReload}
        />

        {!loading && !error && (
          <div className="table-responsive">
            <Table className="align-middle">
              <thead className="table-light">
                <tr>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Permisos asignados</th>
                  <th>Usuarios asignados</th>
                  <th>Estado</th>
                  <th className="text-center">Acción</th>
                </tr>
              </thead>
              <tbody>
                {roles.length === 0 && (
                  <tr>
                    <td colSpan={6} className="text-center text-muted py-4">
                      No existen roles configurados
                    </td>
                  </tr>
                )}
                {roles.map((rol) => (
                  <tr key={rol.id}>
                    <td className="fw-medium">{rol.nombre}</td>
                    <td>{rol.descripcion || "Sin descripción"}</td>
                    <td>{rol.permisos.length}</td>
                    <td>{typeof rol.usuariosAsignados === "number" ? rol.usuariosAsignados : 0}</td>
                    <td>
                      {rol.activo ? (
                        <span className="badge bg-success-subtle text-success">Activo</span>
                      ) : (
                        <span className="badge bg-danger-subtle text-danger">Inactivo</span>
                      )}
                    </td>
                    <td className="text-center">
                      <UncontrolledDropdown>
                        <DropdownToggle tag="button" className="btn btn-soft-secondary btn-sm">
                          <i className="ri-more-fill align-middle" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          <DropdownItem
                            disabled={!canEdit}
                            onClick={() => {
                              if (!canEdit) return;
                              onEdit(rol);
                            }}
                          >
                            <i className="ri-pencil-fill align-bottom me-2 text-muted" />
                            Editar
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default RolesTab;
